<div class="action-view-overview">
    @if (isTimedOut) {
        <p class="text-danger">{{ timeoutMessage }}</p>
    } @else if (!results.length) {
        <p class="text-muted">No tasks matched the selected criteria.</p>
    }

    @for (taskSeries of series; track taskSeries.key) {
        @if (groupByCount > 0) {
            <div class="task-series-header">
                <button type="button" class="btn btn-link p-0" (click)="drilldownSeries(taskSeries)">
                    {{ taskSeries.name }}
                </button>
            </div>
        }
        @for (overviewTable of taskSeries.tables; track overviewTable.key) {
            @if (groupByCount === 2) {
                <div class="task-type-header">
                    <button type="button" class="btn btn-link p-0" (click)="drilldownFirstGroup(overviewTable)">
                        {{ overviewTable.name }}
                    </button>
                </div>
            }
            <div class="table-responsive mb-4">
                <table class="task-table">
                    <thead>
                        <tr>
                            <th class="name-header"></th>
                            @for (header of headers; track header) {
                                <th>
                                    @if (isColumnSelectable(header)) {
                                        <button
                                            type="button"
                                            class="btn btn-link p-0"
                                            (click)="drilldownColumn(header, overviewTable.rows)"
                                        >
                                            {{ header }}
                                        </button>
                                    } @else {
                                        {{ header }}
                                    }
                                </th>
                            }
                            @if (criteria.showTotals) {
                                <th>Total</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of overviewTable.rows; track $index) {
                            <tr>
                                <td>
                                    <button type="button" class="btn btn-link p-0" (click)="drilldownRow(row, null)">
                                        {{ rowLabel(row) }}
                                    </button>
                                </td>
                                @for (item of row.data; track item.sequence) {
                                    <td [ngClass]="columnClass(item.sequence)">
                                        @if (item.ready || item.notReady) {
                                            @if (item.ready) {
                                                <button
                                                    type="button"
                                                    class="wide-value-badge"
                                                    (click)="drilldownCell(row, item, 'ready')"
                                                >
                                                    {{ item.ready }}
                                                </button>
                                            }
                                            @if (item.notReady) {
                                                <button
                                                    type="button"
                                                    class="wide-value-badge"
                                                    (click)="drilldownCell(row, item, 'not ready')"
                                                >
                                                    ({{ item.notReady }})
                                                </button>
                                            }
                                        } @else if (item.value) {
                                            <button
                                                type="button"
                                                class="value-badge"
                                                (click)="drilldownCell(row, item, null)"
                                            >
                                                {{ item.value }}
                                            </button>
                                        }
                                    </td>
                                }
                                @if (criteria.showTotals) {
                                    <td>
                                        @if (row.totals.ready || row.totals.notReady) {
                                            <button
                                                type="button"
                                                class="wide-value-badge"
                                                (click)="drilldownRow(row, 'ready')"
                                            >
                                                {{ row.totals.ready }}
                                            </button>
                                            <button
                                                type="button"
                                                class="wide-value-badge"
                                                (click)="drilldownRow(row, 'not ready')"
                                            >
                                                ({{ row.totals.notReady }})
                                            </button>
                                        } @else {
                                            <button type="button" class="value-badge" (click)="drilldownRow(row, null)">
                                                {{ row.totals.value }}
                                            </button>
                                        }
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    }

    @if (criteria.showTotals && results.length) {
        <table class="task-table mt-4">
            <thead>
                <tr>
                    <th class="name-header"></th>
                    @for (header of headers; track header) {
                        <th>{{ header }}</th>
                    }
                    <th>Grand Total</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Total</td>
                    @for (item of organizeTotals; track item.sequence) {
                        <td [ngClass]="columnClass(item.sequence)">
                            @if (item.ready || item.notReady) {
                                <button
                                    type="button"
                                    class="wide-value-badge"
                                    (click)="drilldownColumn(item.label, undefined, 'ready')"
                                >
                                    {{ item.ready }}
                                </button>
                                <button
                                    type="button"
                                    class="wide-value-badge"
                                    (click)="drilldownColumn(item.label, undefined, 'not ready')"
                                >
                                    ({{ item.notReady }})
                                </button>
                            } @else {
                                <button type="button" class="value-badge" (click)="drilldownColumn(item.label)">
                                    {{ item.value }}
                                </button>
                            }
                        </td>
                    }
                    <td>
                        @if (grandTotals.ready || grandTotals.notReady) {
                            <button type="button" class="wide-value-badge" (click)="drilldownGrandTotal('ready')">
                                {{ grandTotals.ready }}
                            </button>
                            <button type="button" class="wide-value-badge" (click)="drilldownGrandTotal('not ready')">
                                ({{ grandTotals.notReady }})
                            </button>
                        } @else {
                            <button type="button" class="value-badge" (click)="drilldownGrandTotal(null)">
                                {{ grandTotals.value }}
                            </button>
                        }
                    </td>
                </tr>
            </tbody>
        </table>
    }
</div>
